import { tw } from '@/utils/tw';
import BaseVideoTheme from 'base/components/Video/theme';

export default tw.theme({
  extend: BaseVideoTheme,
  slots: {
    icon: ['text-red'],
  },
});
